/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiCurrencyDto,
  ApiCurrencyRateBaseDto,
  ApiCurrencyRateDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Currency<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyControllerGetAllRates
   * @summary Get all currency rates
   * @request GET:/currency/rates
   * @secure
   * @response `200` `(ApiCurrencyRateDto)[]` List of currency rates.
   * @response `500` `void` Failed to retrieve currency rates.
   */
  currencyControllerGetAllRates = (params: RequestParams = {}) =>
    this.request<ApiCurrencyRateDto[], ApiBaseError>({
      path: `/currency/rates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyControllerGetCurrencyRates
   * @summary Get all currency rates for base currency
   * @request POST:/currency/rates/base
   * @secure
   * @response `200` `(ApiCurrencyRateBaseDto)[]` List of currency rates for base currency.
   * @response `500` `void` Failed to retrieve currency rates.
   */
  currencyControllerGetCurrencyRates = (
    data: ApiCurrencyDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCurrencyRateBaseDto[], ApiBaseError>({
      path: `/currency/rates/base`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyControllerUpdateRates
   * @summary Update currency rates from API
   * @request POST:/currency/rates/update
   * @secure
   * @response `200` `void` Currency rates updated successfully.
   * @response `500` `void` Failed to update currency rates.
   */
  currencyControllerUpdateRates = (params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/currency/rates/update`,
      method: "POST",
      secure: true,
      ...params,
    });
}
